// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ezQmf","small":"_5SqG9","large":"azPPp","dark":"DtBQI","outline":"dA03y","back":"bEmC6","blue":"_6N94f"};